import { OPEN_KEYBOARD_SHORTCUTS_DIALOG, REGISTER_KEYBOARD_SHORTCUT, UNREGISTER_KEYBOARD_SHORTCUT } from './actionTypes';

/**
 * Opens the dialog showing available keyboard shortcuts.
 *
 * @returns {{
 *     type: OPEN_KEYBOARD_SHORTCUTS_DIALOG
 * }}
 */
export function openKeyboardShortcutsDialog() {
    return {
        type: OPEN_KEYBOARD_SHORTCUTS_DIALOG
    };
}

/**
* Action to unregister a shortcut.
*
* @param {string} character - The character of the shortcut to unregister.
* @param {boolean} altKey - Whether the shortcut used altKey.
* @returns {AnyAction}
*/
export const unregisterShortcut = (character, altKey = false) => {
    return {
        alt: altKey,
        type: UNREGISTER_KEYBOARD_SHORTCUT,
        character
    };
};

/**
 * Action to register a new shortcut.
 *
 * @param {IKeyboardShortcut} shortcut - The shortcut to register.
 * @returns {AnyAction}
*/
export const registerShortcut = shortcut => {
    return {
        type: REGISTER_KEYBOARD_SHORTCUT,
        shortcut
    };
};
